import { Warehouse, WarehouseType } from '../store'

export type WarehouseByPatternArgs = {
  pattern: string
  warehouseTypes?: WarehouseType[]
}

export function buildWarehouseByPatternArgs(args: WarehouseByPatternArgs): Record<string, string> {
  return {
    pattern: args.pattern,
    warehouseTypes: args.warehouseTypes.join(','),
  }
}

export type TWarehouse = Warehouse

export type WarehouseByPatternResponse = TWarehouse[]
